package event

enum class EventDate(
    val dateStartAndEnd:Pair<String,String>?,
){
    NO_EVENT(
        dateStartAndEnd = null
    ),
    NEW_YEAR_ON_LAST(
        dateStartAndEnd =  "25.12" to "31.12"
    ),
    NEW_YEAR_ON_FIRST(
        dateStartAndEnd =  "01.01" to "08.01"
    ),
}